// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  shell: {
    debug: false,
    networkDelay: 2000
  },
  // apiUrl: 'http://backend.local/api/v1',
  apiUrl: 'https://lkbackend.veedo.ru/api/v1',
  // apiUrl: 'http://158.160.150.161:8000/api/v1',
  oneSignalAppId: 'e97824fc-24bd-44ab-b727-d90a67904021',
  googleSenderId: '83064110511',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
